import { ListItemIcon, ListItemText } from "@mui/material";
import { Building07Icon, Typography } from "components";
import OrganizationDialog from "components/organisms/AccountMenu/OrganizationDialog";
import { useAppSelector } from "stores";
import { useSystemHook } from "stores/System";

import { List, ListItemButton } from "../Sidebar/Sidebar.styles";

const OrgMenuItem = (props: { collapsed: boolean }) => {
  const { onToggleOrgDialog } = useSystemHook();
  const { collapsed } = props;
  const orgSelected = useAppSelector((state) => state.auth.orgSelected);
  const organizationDialog = useAppSelector(
    (state) => state.system.organizationDialog
  );

  return (
    <>
      <List component="nav" disablePadding>
        <ListItemButton
          level={1}
          collapsed={collapsed}
          onClick={onToggleOrgDialog}
        >
          <ListItemIcon>
            <Building07Icon />
          </ListItemIcon>
          <ListItemText>
            <Typography>{orgSelected?.name}</Typography>
          </ListItemText>
        </ListItemButton>
      </List>
      {organizationDialog && (
        <OrganizationDialog onToggle={onToggleOrgDialog} />
      )}
    </>
  );
};

export default OrgMenuItem;
